import {
    FETCH_PAYMENT_METHODS,
    FETCH_PAYMENT_METHODS_SUCCESS,
    FETCH_PAYMENT_METHODS_FAILED,
    UPDATE_WALLET_BALANCE,
    UPDATE_WALLET_BALANCE_SUCCESS,
    UPDATE_WALLET_BALANCE_FAILED,
    CLEAR_PAYMENT_MESSAGES,
    UPDATE_PAYMENT_METHOD
} from "../store/types";
import { RequestPushMsg } from '../other/NotificationFunctions';
import { buildWalletNotification } from '../other/walletNotifyMessage';
import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { onValue, get, update, push, runTransaction } from "firebase/database";
import { callSecureFunction } from '../other/secureFunctions';

export const fetchPaymentMethods = () => (dispatch) => {

    const {
      config,
      paymentSettingsRef
    } = firebase;
  
    dispatch({
      type: FETCH_PAYMENT_METHODS,
      payload: null
    });

    const usertype = store.getState().auth.profile.usertype;

    if(usertype == 'admin'){
        onValue(paymentSettingsRef, snapshot => {
            const data = snapshot.val(); 
            if(data){
              dispatch({
                type: FETCH_PAYMENT_METHODS_SUCCESS,
                payload: data
              });
            } else {
              dispatch({
                type: FETCH_PAYMENT_METHODS_FAILED,
                payload: store.getState().languagedata.defaultLanguage.no_provider_found,
              });
            }
          });
    } else { 
        const settings = store.getState().settingsdata.settings;
        let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app`
        let url = `${host}/get_providers`;
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.length > 0) {
                    dispatch({
                        type: FETCH_PAYMENT_METHODS_SUCCESS,
                        payload: responseJson,
                    });
                }else{
                    dispatch({
                        type: FETCH_PAYMENT_METHODS_FAILED,
                        payload: store.getState().languagedata.defaultLanguage.no_provider_found,
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_PAYMENT_METHODS_FAILED,
                    payload: store.getState().languagedata.defaultLanguage.provider_fetch_error + ": " + error.toString(),
                });
            });
    }
  };

  export const editPaymentMethods = (data) => (dispatch) => {
    const {
        paymentSettingsRef
    } = firebase;
    dispatch({
      type: UPDATE_PAYMENT_METHOD,
      payload: data 
    });
    update(paymentSettingsRef, data);
  }
  


export const clearMessage = () => (dispatch) => {
    dispatch({
        type: CLEAR_PAYMENT_MESSAGES,
        payload: null,
    });    
};


export const addToWallet = (uid, amount, note = 'AdminCredit') => async (dispatch) => {
    const {
        walletHistoryRef,
        singleUserRef,
        settingsRef
    } = firebase;

    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });

    try {
        const settingsdata = await get(settingsRef);
        const settings = settingsdata.val() || {};
        const userSnap = await get(singleUserRef(uid));
        const user = userSnap.val();

        if (!user) {
            dispatch({ type: UPDATE_WALLET_BALANCE_FAILED, payload: 'user_not_found' });
            return { success: false };
        }

        const credit = parseFloat(amount);
        if (!(credit > 0)) {
            dispatch({ type: UPDATE_WALLET_BALANCE_FAILED, payload: 'invalid_amount' });
            return { success: false };
        }

        const decimal = typeof settings.decimal === 'number' ? settings.decimal : 2;
        const currentBal = parseFloat(user.walletBalance);
        const base = Number.isFinite(currentBal) ? currentBal : 0;
        const walletBalance = parseFloat((base + credit).toFixed(decimal));

        const updates = { walletBalance };
        const minKeep = settings.driver_min_balance !== null && settings.driver_min_balance !== undefined
            ? parseFloat(settings.driver_min_balance)
            : (settings.driver_activation_fee !== null && settings.driver_activation_fee !== undefined
                ? parseFloat(settings.driver_activation_fee)
                : null);
        if (
            user.usertype === 'driver'
            && Number.isFinite(minKeep)
            && walletBalance >= minKeep
            && user.driverActiveStatus === false
        ) {
            updates.driverActiveStatus = true;
        }

        await update(singleUserRef(uid), updates);

        const details = {
            type: 'Credit',
            amount: credit,
            date: Date.now(),
            txRef: note || 'AdminCredit',
        };
        if (note && note !== 'AdminCredit') {
            details.note = note;
        }
        await push(walletHistoryRef(uid), details);

        if (user.pushToken) {
            const lang = store.getState().languagedata.defaultLanguage;
            const notification = buildWalletNotification({
                type: 'credit',
                amount: credit,
                description: note || 'AdminCredit',
                settings,
                language: lang,
                note: note && note !== 'AdminCredit' ? note : undefined,
            });
            RequestPushMsg(
                user.pushToken,
                {
                    title: notification.title,
                    msg: notification.msg,
                    screen: 'Wallet'
                }
            );
        }

        dispatch({ type: UPDATE_WALLET_BALANCE_SUCCESS, payload: null });
        return { success: true, walletBalance };
    } catch (error) {
        dispatch({
            type: UPDATE_WALLET_BALANCE_FAILED,
            payload: error.code + ': ' + error.message,
        });
        return { success: false, error };
    }
};


// Recarga del saldo de publicidad desde la billetera. Mínimo configurable
// (200.000 por defecto). Mueve dinero de walletBalance -> adBalance.
export const rechargeAdBalance = (profile, amount) => async (dispatch) => {
    dispatch({ type: UPDATE_WALLET_BALANCE, payload: null });

    try {
        const settings = store.getState().settingsdata.settings;
        const minRecharge = settings && settings.ad_min_recharge != null ? parseFloat(settings.ad_min_recharge) : 200000;
        const amt = parseFloat(amount);

        if (!(amt > 0)) {
            dispatch({ type: UPDATE_WALLET_BALANCE_FAILED, payload: store.getState().languagedata.defaultLanguage.valid_amount });
            return { success: false, error: 'invalid_amount' };
        }
        if (amt < minRecharge) {
            const msg = (store.getState().languagedata.defaultLanguage.ad_min_recharge_msg || 'La recarga mínima de publicidad es') + ' ' + minRecharge;
            dispatch({ type: UPDATE_WALLET_BALANCE_FAILED, payload: msg });
            return { success: false, error: 'min_recharge', min: minRecharge };
        }

        const result = await callSecureFunction('recharge_ad_balance', { amount: amt });
        dispatch({ type: UPDATE_WALLET_BALANCE_SUCCESS, payload: null });
        return { success: true, adBalance: result.adBalance };
    } catch (error) {
        const lang = store.getState().languagedata.defaultLanguage;
        const msg = error.message === 'insufficient'
            ? (lang.insufficient_balance || 'Saldo insuficiente para completar el pago.')
            : (error.message || 'recharge_failed');
        dispatch({ type: UPDATE_WALLET_BALANCE_FAILED, payload: msg });
        return { success: false, error: error.message };
    }
};


export const withdrawBalance = (profile, amount, fees) => async (dispatch) => {
    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });

    try {
        const settings = store.getState().settingsdata.settings;
        const requested = parseFloat(amount);
        if (!(requested > 0)) {
            dispatch({ type: UPDATE_WALLET_BALANCE_FAILED, payload: store.getState().languagedata.defaultLanguage.valid_amount });
            return;
        }

        if (!(profile.bankName && profile.bankAccount)) {
            dispatch({ type: UPDATE_WALLET_BALANCE_FAILED, payload: store.getState().languagedata.defaultLanguage.bank_details_missing || 'Agrega tus datos bancarios antes de retirar.' });
            return;
        }

        await callSecureFunction('withdraw_balance', { amount: requested, fees: fees || {} });
        dispatch({ type: UPDATE_WALLET_BALANCE_SUCCESS, payload: null });
    } catch (error) {
        const lang = store.getState().languagedata.defaultLanguage;
        let msg;
        if (error.code === 'min_balance' || error.message === 'min_balance') {
            const minKeep = error.details?.minKeep
                || (settings && settings.driver_min_balance != null ? parseFloat(settings.driver_min_balance) : 120000);
            const maxW = error.details?.maxWithdraw;
            msg = (lang.withdraw_keep_min || 'Debes mantener ') + (settings.symbol || '') + minKeep
                + (lang.withdraw_keep_min_end || ' en tu billetera para seguir operando.')
                + (maxW != null ? (' Máximo: ' + (settings.symbol || '') + maxW) : '');
        } else {
            msg = error.message === 'insufficient'
                ? lang.withdraw_more
                : (error.message || 'withdraw_failed');
        }
        dispatch({ type: UPDATE_WALLET_BALANCE_FAILED, payload: msg });
    }
};
